import { Visual } from "../models/Visual";
import { BaseAnimator } from "./BaseAnimator";
import { QRAnimator } from "./QRAnimator";
import { RobotData, RobotVisual } from "./RobotVisual";
import * as THREE from "three";

export interface QuadrupedData extends RobotData {
}

export class QuadrupedVisual extends RobotVisual implements QuadrupedData {
  visualizeSensors = true;

  public getType(): string {
    return 'QuadrupedVisual';
  }
  
  protected async onLoaded(): Promise<void> {
    await super.onLoaded();
    // const meshes:THREE.Mesh[] = [];
    // this.modelLoader.modelObj!.traverse((child) => {
    //   if (child instanceof THREE.Mesh) {
    //     meshes.push(child);
    //   }
    // });
    
    // if (meshes.length === 0) {
    //   console.warn("No meshes found in the model for QuadrupedVisual.");
    //   return;
    // }
    // meshes[0].material = new THREE.MeshStandardMaterial({
    //   roughness: 0.5,
    //   metalness: 0.5,
    //   color: 0x606060
    // });
    // for(let i = 1; i < meshes.length; i++) {
    //   meshes[i].material = new THREE.MeshStandardMaterial({
    //     roughness: 0.5,
    //     metalness: 0.5,
    //     color: 0x808080
    //   });
    // }
  }

  public createAnimator(): BaseAnimator {
    return new QRAnimator(this.modelLoader);
  }
}